import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, inject, Input, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { tap } from 'rxjs';
import { IconService } from './icon.service';
import { DEFAULT_ICON_SIZE, getSize } from '@ui/icon/icons-utils';

@Component({
	selector: 'tk-icon',
	standalone: true,
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule],
})
export class IconComponent {
	@HostBinding('class') className = 'tk-icon';
	public readonly elementRef = inject(ElementRef<Element>);
	private innerSrc = '';
	private readonly iconService = inject(IconService);
	private renderer = inject(Renderer2);

	private _src = '';

	get src(): string {
		return this._src;
	}

	@Input('icon') set src(value: string) {
		if (this._src === value) {
			return;
		}

		this._src = value;

		this.iconService
			.getIconCached(value)
			.pipe(
				tap(src => {
					if (!src) {
						throw Error(`Could not load icon with name ${this.src}`);
					}
				}),
			)
			.subscribe(src => {
				this.innerSrc = src;
				this.updateSize();
				this.elementRef.nativeElement.innerHTML = src;
			});
	}

	private _size: string | number | null = null;

	get size(): string | number | null {
		return this._size;
	}

	@Input() set size(value: string | number | null) {
		this._size = value;
		this.updateSize();
	}

	updateSize() {
		if (!this.innerSrc) {
			return;
		}
		const [iconWidth, iconHeight] = getSize(this.innerSrc);
		const width = Number(this._size) || iconWidth || DEFAULT_ICON_SIZE;
		const height = Number(this._size) || iconHeight || DEFAULT_ICON_SIZE;

		this.renderer.setAttribute(this.elementRef.nativeElement, 'style', `width: ${width}px; height: ${height}px`);
	}
}
